import React from "react";
import Loader from "../components/common/loader/loader";

const LoaderPage = () => {
  return (
    <div className="min-h-screen h-screen w-full overflow-hidden bg-blackLight">
      <Loader pageLoader />
    </div>
  );
};

export default LoaderPage;
